import React, { Component } from "react";
import { Button } from "semantic-ui-react";

/**
 * @date 09/09/2018
 * @author Martin Gabor
 */

class LoadButtonPanel extends Component {
  state = {
    loaded: false,
  };

  render() {
    const { createContentCb, iconName, loadText } = this.props;

    if (!this.state.loaded) {
      return (
        <div style={{ width: "100%", padding: "10px" }}>
          <div style={{ border: "1px dashed #ccc", borderRadius: "10px", padding: "30px", textAlign: "center" }}>
            <Button icon={iconName} content={loadText} onClick={() => this.setState({ loaded: true })} />
          </div>
        </div>
      );
    } else {
      return createContentCb();
    }
  }
}

export default LoadButtonPanel;



// WEBPACK FOOTER //
// ./src/components/LoadButtonPanel.js